import { updateChatbotState } from "./Utils";
import ValidarAdeudos from "./ValidarAdeudos";
import {API_BASE} from "../../../services/apirest"; // Asegúrate que la ruta es correcta

export const manejarValidacionCompleta = async (datos, setState, createChatBotMessage) => {
  const url = `${API_BASE}/clientes.php?` +
      `direccion=${encodeURIComponent(datos.direccion)}&` +
      `telefono=${encodeURIComponent(datos.telefono)}&` +
      `email=${encodeURIComponent(datos.email)}&` +
      `nombre_cuenta=${encodeURIComponent(datos.nombre_cuenta)}`;

  try {
    const response = await fetch(url);
    const result = await response.json();
    console.log("Respuesta del backend:", result);

    // Recolectar posibles clientes desde distintas estructuras de respuesta
    let clientes = [];
    if (result.result) {
      if (Array.isArray(result.result)) {
        clientes = result.result;
      } else if (Array.isArray(result.result.clientes)) {
        clientes = result.result.clientes;
      } else if (result.result.cliente) {
        clientes = [result.result.cliente];
      }
    }

    if (!clientes || clientes.length === 0) {
      updateChatbotState(
          setState,
          createChatBotMessage(
              "✅ El cliente no se encuentra registrado.",
              { widget: "opcionesInicio" }
          )
      );
      return;
    }

    // Si solo hay un cliente, mostrar su análisis directamente
    if (clientes.length === 1) {
      const validador = new ValidarAdeudos(clientes[0]);
      const mensaje = validador.validarAdeudos();

      updateChatbotState(setState, createChatBotMessage(mensaje, { widget: "opcionesInicio" }));
    } else {
      // Si hay varios, mostrar cada uno de forma separada
      let mensajeFinal = `🔎 Se encontraron ${clientes.length} coincidencias:\n\n`;

      clientes.forEach((cliente, index) => {
        const validador = new ValidarAdeudos(cliente);
        const mensajeCliente = validador.validarAdeudos();
        mensajeFinal += `Cliente ${index + 1}:\n${mensajeCliente}\n\n`;
      });

      updateChatbotState(setState, createChatBotMessage(mensajeFinal, { widget: "opcionesInicio" }));
    }

  } catch (error) {
    console.error("Error en la validación completa:", error);
    updateChatbotState(
        setState,
        createChatBotMessage(`🚨 Error en validación: ${error.message}`)
    );
  }
};